import { render, staticRenderFns } from "./InjuryTypeList.vue?vue&type=template&id=21883fd6"
import script from "./InjuryTypeList.vue?vue&type=script&lang=js"
export * from "./InjuryTypeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports